const matchesCaseInsensitive = (str1, str2) => {
  if (!str1 || !str2) return false

  return str1?.localeCompare(str2, undefined, { sensitivity: 'accent' }) === 0
}

export default matchesCaseInsensitive
